import { useTranslation } from 'react-i18next'
import React from 'react'

import { Grid } from '../../../packages/kiti/components/structure/Grid'
import { useCloseModal, useModalData } from '../../../components/modals/ModalsContext'
import { useMailPublicExecution } from './_requests/mailPublicExecution'
import Button from '../../../packages/kiti/components/actions/Button'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'

const MailPublicExecutionConfirmation = () => {
  const { t } = useTranslation()
  const ids = useModalData()
  const closeModal = useCloseModal()
  const [send, { loading }] = useMailPublicExecution()

  return (
    <>
      <Title size="h4" align="center">
        Enviando link público de execução de {ids?.length} {t('entity.serviceOrder', { count: ids?.length })}
      </Title>
      <Separator />
      <Text align="center">Essa ação irá enviar um link público para o usuário da atividade responder.</Text>
      <Separator weight={6} />
      <Grid gutter={0.2} justify="center">
        <Button transparent color="dark3" onClick={closeModal}>
          Cancelar
        </Button>

        <Button loading={loading} onClick={send}>
          Enviar
        </Button>
      </Grid>
    </>
  )
}

export default MailPublicExecutionConfirmation
